var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ag-cell-label-container",attrs:{"id":"grid-total-line"},on:{"click":_vm.toggleTotalLegend}},[_c('div',{staticClass:"ag-header-cell-label"},[_vm._v("-")])])
}
var staticRenderFns = []

export { render, staticRenderFns }